<!-- Bar search / Title / Breadcrumbs -->
<div *ngIf="_headerTextService.getPosicion() === posicion" class="w-full flex-1 min-w-0 px-2 sm:px-3 py-1 flex items-center overflow-hidden">
    <ng-container *ngIf="hasBreadcrumbs(); else normalTitle">
        <!-- Breadcrumbs Fluidos y Adaptados tanto para Mobile como Desktop -->
        <nav aria-label="Breadcrumb" class="flex items-center flex-nowrap sm:flex-wrap gap-1 sm:gap-1.5 text-xs sm:text-sm font-medium p-0.5 overflow-hidden max-w-full">
            <ng-container *ngFor="let breadcrumb of getBreadcrumbs(); let last = last">
                <!-- Niveles Anteriores (Módulo Padre) -->
                <ng-container *ngIf="!last">
                    <span class="inline-flex items-center gap-1 min-w-0 shrink max-w-[110px] sm:max-w-none">
                        <!-- Icono del breadcrumb si existe -->
                        <mat-icon *ngIf="breadcrumb.icon" class="icon-size-3.5 sm:icon-size-4 text-slate-500 shrink-0 !m-0" [svgIcon]="breadcrumb.icon"></mat-icon>
                        
                        <!-- Si tiene URL, es un link -->
                        <a *ngIf="breadcrumb.url" [routerLink]="[breadcrumb.url]" [queryParams]="breadcrumb.queryParams"
                            class="hover:text-blue-600 transition-colors cursor-pointer text-slate-500 hover:text-blue-600 font-semibold text-xs sm:text-sm md:text-base truncate">
                            {{ breadcrumb.text }}
                        </a>
                        <!-- Si no, texto plano -->
                        <span *ngIf="!breadcrumb.url" class="text-slate-500 font-semibold text-xs sm:text-sm md:text-base truncate">
                            {{ breadcrumb.text }}
                        </span>
                    </span>
                    
                    <!-- Icono Separador: chevron_right -->
                    <mat-icon class="icon-size-3.5 sm:icon-size-4 text-slate-400 shrink-0 !m-0">chevron_right</mat-icon>
                </ng-container>

                <!-- Nivel Activo (Página Actual) -->
                <ng-container *ngIf="last">
                    <span class="inline-flex items-center gap-1 text-slate-900 font-bold sm:font-extrabold text-xs sm:text-sm md:text-base lg:text-lg min-w-0 shrink truncate">
                        <mat-icon *ngIf="breadcrumb.icon" class="icon-size-3.5 sm:icon-size-4.5 text-slate-700 shrink-0 !m-0" [svgIcon]="breadcrumb.icon"></mat-icon>
                        <span class="truncate">{{ breadcrumb.text }}</span>
                    </span>
                </ng-container>
            </ng-container>
        </nav>
    </ng-container>

    <ng-template #normalTitle>
        <span class="text-slate-800 font-bold text-xs sm:text-sm md:text-base lg:text-2xl dark:text-white p-1 truncate leading-tight">
            {{ getTitulo() }}
        </span>
    </ng-template>
</div>